import { cva } from 'class-variance-authority';

/**
 * Variantes do botão em arquivo separado do componente: exportar constantes
 * junto com componentes desativa o fast refresh do Vite.
 */
export const variantesBotao = cva(
  'inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium ' +
    'transition-colors focus-visible:outline-foco focus-visible:outline-2 ' +
    'focus-visible:outline-offset-2 disabled:pointer-events-none disabled:opacity-50 ' +
    "[&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variante: {
        primario: 'bg-marca text-marca-contraste hover:bg-marca-forte',
        secundario: 'bg-silenciado text-fundo-texto hover:bg-borda',
        contorno: 'border border-borda bg-cartao hover:bg-silenciado',
        destrutivo: 'bg-destrutivo text-destrutivo-texto hover:opacity-90',
        fantasma: 'hover:bg-silenciado',
        link: 'text-marca underline-offset-4 hover:underline',
      },
      // Alvos de toque maiores no celular e compactos no desktop: a
      // recomendação de acessibilidade para toque é 44px, e um botão de 32px
      // ao lado de outro erra com frequência em tela pequena.
      tamanho: {
        sm: 'h-9 px-3 text-xs sm:h-8',
        md: 'h-11 px-4 sm:h-10',
        lg: 'h-12 px-6 text-base sm:h-11',
        icone: 'size-11 sm:size-10',
      },
    },
    defaultVariants: {
      variante: 'primario',
      tamanho: 'md',
    },
  },
);
